export const LOAD_USER_STATES = "LOAD_USER_STATES"
export const SAVE_TIRE_DETAILS = "SAVE_TIRE_DETAILS"
export const SAVE_TIRE_SIZE_DETAILS = "SAVE_TIRE_SIZE_DETAILS"
export const SAVE_SELECTED_SHOP = "SAVE_SELECTED_SHOP"
export const SAVE_INSTALLATION_DATE = "SAVE_INSTALLATION_DATE"
export const SAVE_SELECTED_TIRE = "SAVE_SELECTED_TIRE"
export const SAVE_SELECTED_TIRE_OBJECT = "SAVE_SELECTED_TIRE_OBJECT"
export const RESET_TIRE_DATA = "RESET_TIRE_DATA"
export const USER_NOT_LOADING = "USER_NOT_LOADING"

export const saveTireDetails = (arr) => ({
  type: SAVE_TIRE_DETAILS,
  payload: { arr }
})

export const saveTireSizeDetails = (selectedTireData) => ({
  type: SAVE_TIRE_SIZE_DETAILS,
  payload: { selectedTireData }
})

export const saveSelectedTire = (selectedTire) => ({
  type: SAVE_SELECTED_TIRE,
  payload: { selectedTire }
})

export const saveSelectedShop = (selectedShop) => ({
  type: SAVE_SELECTED_SHOP,
  payload: { selectedShop }
})

export const saveInstallationDate = (installationDateTime) => ({
  type: SAVE_INSTALLATION_DATE,
  payload: { installationDateTime }
})

export const resetTireData = () => ({ type: RESET_TIRE_DATA })

// Complex action creators that will be handled by sagas
export const getFilteredListOfTires = (payload) => ({
  type: "GET_FILTERED_LIST_OF_TIRES_SAGA",
  ...payload
})

export const getTireDetails = (payload) => ({
  type: "GET_TIRE_DETAILS",
  payload
})

export const getRimSize = (payload) => ({
  type: "GET_RIM_SIZE_SAGA",
  payload
})

export const getShopsForTire = (payload) => ({
  type: "GET_SHOPS_FOR_TIRE",
  payload
})

export const getTireBookingDetails = (payload) => ({
  type: "GET_TIRE_BOOKING_DETAILS",
  payload
})

export const getTimeSlotsForShop = (payload) => ({
  type: "GET_TIME_SLOTS_FOR_SHOP",
  payload
})

export const getTireOrderDetails = (payload) => ({
  type: "GET_TIRE_ORDER_DETAILS",
  payload
})

export const updateGuestUserDetails = (user, data) => ({
  type: "UPDATE_GUEST_USER_DETAILS",
  payload: { user, data }
})

export const updateVehicleDetails = (user, data, vehicleId) => ({
  type: "UPDATE_VEHICLE_DETAILS",
  payload: { user, data, vehicleId }
})
